import { clearLocalSession, setLocalSession } from "../api/client";
import { theme, card, btnSecondary } from "../theme";
import { TotpEnrolment } from "../components/TotpEnrolment";
import type { CurrentUser } from "../auth/useCurrentUser";

// The gate a password account sits behind until its authenticator app is
// enrolled. The session it holds can reach nothing else (the API enforces
// that), so this is the whole page: enrol, save the recovery codes, carry on.

export function MfaEnrolPage({ user, onDone }: { user: CurrentUser; onDone: () => void }) {
  return (
    <div style={{ minHeight: "100vh", background: theme.color.bg, fontFamily: theme.font, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 560 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
          <img src="/abacas-logo.png" alt="" width={40} height={40} style={{ objectFit: "contain" }} />
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: theme.color.heading }}>One more step</div>
            <div style={{ fontSize: 12, color: theme.color.subtle }}>
              Signed in as <strong>{user.email}</strong>. Password accounts always use an authenticator app as a second factor.
            </div>
          </div>
        </div>

        <div style={card}>
          <TotpEnrolment
            onDone={({ accessToken }) => {
              setLocalSession(accessToken, true);
              onDone();
            }}
          />
        </div>

        <div style={{ marginTop: 14, textAlign: "center" }}>
          <button
            type="button"
            onClick={() => { clearLocalSession(); window.location.href = "/login"; }}
            style={{ ...btnSecondary, fontSize: 12 }}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
